export const Particulates = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <filter
        x="-14.6%"
        y="-8.4%"
        width="129.2%"
        height="133.5%"
        filterUnits="objectBoundingBox"
        id="qdnztu12ua"
      >
        <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" in="shadowBlurOuter1" />
      </filter>
      <path
        d="M8.453 11.165v-4.34h4.053V4.292H8.453V.002H5.851v4.29H1.8v2.533h4.052v4.34h2.602zm19.385.692V8.723h2.927v-1.83h-2.927V3.796h-1.88v3.099h-2.926v1.829h2.927v3.134h1.88zM15.785 29.81v-3.375h3.152v-1.97h-3.152v-3.337h-2.023v3.337H10.61v1.97h3.152v3.375h2.023zm2.384-14.333a3.4 3.4 0 0 0 3.406-3.392 3.4 3.4 0 0 0-3.406-3.392 3.4 3.4 0 0 0-3.407 3.392 3.4 3.4 0 0 0 3.407 3.392zm5.677 7.915a2.266 2.266 0 0 0 2.271-2.261 2.266 2.266 0 0 0-2.27-2.262 2.266 2.266 0 0 0-2.272 2.262 2.266 2.266 0 0 0 2.271 2.261zm-20.44 1.13a3.4 3.4 0 0 0 3.407-3.391 3.4 3.4 0 0 0-3.406-3.392A3.4 3.4 0 0 0 0 21.13a3.4 3.4 0 0 0 3.407 3.392z"
        id="rel581uwkb"
      />
    </defs>
    <g transform="translate(2.938 .925)" fill="none" fillRule="evenodd">
      <use fill="#000" filter="url(#qdnztu12ua)" xlinkHref="#rel581uwkb" />
      <use fill="#FFF" xlinkHref="#rel581uwkb" />
    </g>
  </svg>
);
